import React, { useState, useEffect, useCallback } from 'react';
import { Box, Button, MobileStepper } from '@mui/material';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';

const TestimonialCarousel = ({ items }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [opacity, setOpacity] = useState(1);
  const maxSteps = items.length;
  const transitionDuration = 500;

  // --- Lógica de Transição (Fade In/Out) ---
  const handleTransition = useCallback((nextStep) => {
    setOpacity(0); // Oculta
    setTimeout(() => {
      setActiveStep(nextStep); // Troca o conteúdo
      requestAnimationFrame(() => {
        setOpacity(1); // Mostra
      });
    }, transitionDuration);
  }, [transitionDuration]);

  // --- Navegação ---
  const handleNext = useCallback(() => {
    const nextStep = activeStep === maxSteps - 1 ? 0 : activeStep + 1;
    handleTransition(nextStep);
  }, [activeStep, maxSteps, handleTransition]);

  const handleBack = () => {
    const prevStep = activeStep === 0 ? maxSteps - 1 : activeStep - 1;
    handleTransition(prevStep);
  };

  // --- Autoplay ---
  useEffect(() => {
    const timer = setTimeout(() => {
      handleNext();
    }, 6000); // Aumentei para 6s pois depoimentos levam mais tempo para ler
    return () => clearTimeout(timer);
  }, [activeStep, handleNext]);

  if (!items || items.length === 0) return null;

  const currentItem = items[activeStep];

  return (
    <Box sx={{ width: '100%', position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      
      {/* Container do Slide (Foto + Texto) */}
      <Box 
        sx={{ 
          width: '100%', 
          maxWidth: 600, // Limita a largura para não ficar gigante no desktop
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          gap: 2, // Espaço entre a foto e o print do texto
          opacity: opacity,
          transition: `opacity ${transitionDuration}ms ease-in-out`,
          mb: 2
        }}
      >
        {/* 1. FOTO DO ALUNO (Antes/Depois) */}
        <Box 
          component="img"
          src={currentItem.photo}
          alt={`Resultado Aluno ${activeStep + 1}`}
          sx={{
            width: '100%',
            maxHeight: 500, // Altura máxima para não estourar a tela
            objectFit: 'contain',
            borderRadius: 2,
            boxShadow: '0 4px 20px rgba(0,0,0,0.5)'
          }}
        />

        {/* 2. PRINT DO TEXTO (Depoimento) */}
        <Box 
          component="img"
          src={currentItem.text}
          alt={`Depoimento Texto ${activeStep + 1}`}
          sx={{
            width: '90%', // Um pouco menor que a foto para dar hierarquia
            maxWidth: 400,
            objectFit: 'contain',
            borderRadius: 2,
            border: '1px solid rgba(255,255,255,0.1)',
            boxShadow: '0 4px 10px rgba(0,0,0,0.3)'
          }}
        />
      </Box>

      {/* Controles de Navegação */}
      <MobileStepper
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        sx={{ bgcolor: 'transparent', width: '100%', maxWidth: 400 }}
        nextButton={
          <Button size="small" onClick={handleNext} disabled={opacity === 0}>
            Próximo <KeyboardArrowRight />
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={opacity === 0}>
            <KeyboardArrowLeft /> Anterior
          </Button>
        }
      />
    </Box>
  );
};

export default TestimonialCarousel;